import React, { memo, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // useNavigate zamiast useNavigate
import { useTranslation } from 'react-i18next'; // Zastępuje falcon-i18n
import PropTypes from 'prop-types';
import useResponsive from '../../../hooks/useResponsive';
import ProductSidebarAddGroupedProduct from '../ProductSidebarAddGroupedProduct/ProductSidebarAddGroupedProduct';
import ProductSidebarAddSimpleProduct from '../ProductSidebarAddSimpleProduct/ProductSidebarAddSimpleProduct';
import ProductSidebarClub from '../ProductSidebarClub/ProductSidebarClub';
import ProductSidebarDelivery from '../ProductSidebarDelivery/ProductSidebarDelivery';
import ProductSidebarGroupedPromos from '../ProductSidebarGroupedPromos/ProductSidebarGroupedPromos';
import ProductSidebarPhoneOrder from '../ProductSidebarPhoneOrder/ProductSidebarPhoneOrder';
import ProductSidebarQuestions from '../ProductSidebarQuestions/ProductSidebarQuestions';
import ProductSidebarShortDescription from '../ProductSIdebarShortDescription/ProductSidebarShortDescription';
import ProductSidebarWarranty from '../ProductSidebarWarranty/ProductSidebarWarranty';
import { isHR } from '../../../utils/isHr';
import './ProductSidebar.scss';
import PriceBlock from '../PriceBlock/PriceBlock';
import { useUserContext } from '../../../context/UserContext';
import PriceInfo from '../PriceInfo/PriceInfo';
import { BuildAbsoluteUrl } from '../../../utils/urlBuilder';

const ProductSidebar = ({ product, setTab }) => {
    const [waste, setWaste] = useState(false);
    const { t } = useTranslation(); // Zastępuje T z falcon-i18n
    const { isMobile } = useResponsive();
    const navigate = useNavigate(); // Zastępuje useNavigate
    const { user } = useUserContext();

    // Ustawienie początkowego produktu
    const initialProduct = product.__typename === 'GroupedProduct' ? product.items[0].product : product;
    const [currentProduct, setCurrentProduct] = useState(initialProduct);

    const {
        uid,
        sku,
        prices,
        guarantees,
        name,
        swatch_attribute_images,
        categories,
        is_on_order_only,
        days_to_delivery,
        is_saleable
    } = product || {};

    const breadcrumbs = categories && categories[categories.length - 1];
    const { category_id } = (breadcrumbs && breadcrumbs.breadcrumbs[0]) || {};
    const url = BuildAbsoluteUrl(product.canonical_url);

    const subscribeToAlert = (uid) => {
        const encodedUID = atob(uid);
        const redirectPath = `/productalert/add/${encodedUID}${window.location.pathname}`;

        if (!user) {
            navigate(`/customer/login?referrer=${redirectPath}`);
            return;
        }
        navigate(redirectPath);
    };

    // Sprawdzanie odpadów EE
    useEffect(() => {
        if (breadcrumbs && category_id && (category_id === 374 || category_id === 375)) {
            setWaste(true);
        }
    }, [breadcrumbs, category_id]);

    // Aktualizacja produktu
    useEffect(() => {
        setCurrentProduct(initialProduct);
    }, [product]); // initialProduct zależy od product

    const changeProductHandler = (sku) => {
        const selected = product.items.find((item) => item.product.sku === sku);
        if (selected) setCurrentProduct(selected.product);
    };

    return (
        <div className="product-sidebar">
            {isMobile && !!is_on_order_only && days_to_delivery === 0 && (
                <div className="storeOrderTextboxMobile">
                    <p className="storeOrderHoverText">{t('product.orderInTheStoreText')}</p>
                </div>
            )}

            <div className="product-sidebar__sku">
                <span className="product-sidebar__kod">{t('product.code')}:</span>{' '}
                <div className="product-sidebar__code" itemProp="sku">{sku}</div>
            </div>

            {product.__typename === 'GroupedProduct' && (
                <div className="product-sidebar__grouped-product">
                    <ProductSidebarAddGroupedProduct
                        product={product}
                        currentSku={currentProduct.sku}
                        onChangeProduct={changeProductHandler}
                    />
                </div>
            )}

            {currentProduct.prices?.length > 0 && (
                <div className="sidebar-price">
                    <PriceBlock product={currentProduct} shortLabel={false} />
                </div>
            )}
            <PriceInfo product={currentProduct} />
            {currentProduct.__typename === 'SimpleProduct' && (
                <ProductSidebarAddSimpleProduct product={currentProduct} />
            )}
            {currentProduct.__typename === 'GroupedProduct' && (
                <ProductSidebarGroupedPromos product={currentProduct} />
            )}

            <ProductSidebarShortDescription product={product} setTab={setTab} />
            <ProductSidebarDelivery product={currentProduct} />
            {guarantees && <ProductSidebarWarranty data={guarantees} swatch={swatch_attribute_images} />}
            <ProductSidebarClub product={currentProduct} />
            <ProductSidebarQuestions sku={sku} name={name} />
            {/* {isHR && <ProductSidebarHandsfreeDelivery />} */}
            {isHR && <ProductSidebarPhoneOrder />}
            {waste && isHR && (
                <div className="product-sidebar__waste">
                    {t('product.waste')}{' '}
                    <Link to="/kontakt-i-usluge/ee-otpad" className="product-sidebar__waste-link">
                        {t('product.here')}
                    </Link>
                </div>
            )}
        </div>
    );
};

ProductSidebar.propTypes = {
    product: PropTypes.object,
    setTab: PropTypes.func,
};

export default memo(ProductSidebar);